import { $line_size_border_secondary, $radius_border_base } from '../pebbleGlobalToken/border.js';
import { $color_grey_9, $color_brand_light_bg_default, $color_grey_1, $color_grey_8, $color_grey_4, $color_grey_2, $color_grey_3 } from '../pebbleGlobalToken/color.js';
import { $font_weight_medium, $font_weight_regular } from '../pebbleGlobalToken/font.js';

/**
 * 标签页-激活状态的颜色
 * @description enDesc: -
 * @description type: Color
 * @description value: $color-grey-9
 */
var $tabs_active_color = $color_grey_9;

/**
 * 标签页-激活状态字重
 * @description enDesc: -
 * @description type: Font
 * @description value: $font-weight-medium
 */
var $tabs_active_font_weight = $font_weight_medium;

/**
 * 标签页-默认状态字重
 * @description enDesc: -
 * @description type: Font
 * @description value: $font-weight-regular
 */
var $tabs_default_font_weight = $font_weight_regular;

/**
 * 标签页-ink bar 颜色
 * @description enDesc: -
 * @description type: Color
 * @description value: $color_brand_text_defalut
 */
var $tabs_ink_bar_color = $color_grey_9;

/**
 * 标签页-drop 颜色
 * @description enDesc: -
 * @description type: Color
 * @description value: $color_brand_light_bg_default
 */
var $tabs_drop_color = $color_brand_light_bg_default;

/**
 * 标签页-ink bar 颜色
 * @description enDesc: -
 * @description type: Color
 * @description value: $line-size-border-secondary
 */
var $tabs_ink_bar_size = $line_size_border_secondary;

/**
 * 标签页-card 激活状态 颜色
 * @description enDesc: -
 * @description type: Color
 * @description value: $color-grey-1
 */
var $tabs_active_card_color = $color_grey_1;

/**
 * 标签页-默认颜色
 * @description enDesc: -
 * @description type: Color
 * @description value: $color-grey-8
 */
var $tabs_default_color = $color_grey_8;

/**
 * 标签页-禁用颜色
 * @description enDesc: -
 * @description type: Color
 * @description value: $color-grey-4
 */
var $tabs_disable_color = $color_grey_4;

/**
 * 标签页-背景hover颜色
 * @description enDesc: -
 * @description type: Color
 * @description value: $color-grey-2
 */
var $tabs_hover_bgcolor = $color_grey_2;

/**
 * 标签页-card背景hover颜色
 * @description enDesc: -
 * @description type: Color
 * @description value: $color-grey-3
 */
var $tabs_hover_card_bgcolor = $color_grey_3;

/**
 * 标签页-card背景 border hover颜色
 * @description enDesc: -
 * @description type: Color
 * @description value: $color-grey-4
 */
var $tabs_hover_card_bgborder_color = $color_grey_4;

/**
 * 标签页-背景 hover 圆角
 * @description enDesc: -
 * @description type: Border
 * @description value: $radius_border_base
 */
var $tabs_hover_bgradius = $radius_border_base;

export { $tabs_active_card_color, $tabs_active_color, $tabs_active_font_weight, $tabs_default_color, $tabs_default_font_weight, $tabs_disable_color, $tabs_drop_color, $tabs_hover_bgcolor, $tabs_hover_bgradius, $tabs_hover_card_bgborder_color, $tabs_hover_card_bgcolor, $tabs_ink_bar_color, $tabs_ink_bar_size };
